import {
  ActionIcon,
  Box,
  Button,
  Grid,
  Group,
  LoadingOverlay,
  Menu,
  Modal,
  Paper,
  Stack,
  Text, Title
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { PaymentForm } from "../components/payment_form";
import Table from "../components/table";
import { useApp } from "../contexts/app.context";
import { useAuth } from "../contexts/auth.context";
import { GET_BILLING_DETAILS, REFUND_PAYMENT, SAVE_COMPANY_PAYMENT_METHOD, UNSUBSCRIBE_COMPANY } from "../services/payments";
import { formatMoney, getExtenseDatetime, useQuery } from "../utility/util";
import { FaEllipsisV } from "react-icons/fa";
import InputField, { InputFieldTypes } from "../components/input_field";

export default function Billing({ checkout = false }) {
  const [paymentMethod, setPaymentMethod] = useState<any>(null);
  const [coupon, setCoupon] = useState<any>(null);
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState<any>(false);
  const [cancelForm, setCancelForm] = useState<any>(null);
  const [addCustomersForm, setAddCustomersForm] = useState<any>(null);
  const [autoRecharge, setAutoRecharge] = useState<any>({});
  const [loadingUpdatePlan, setLoadingUpdatePlan] = useState<boolean>(false);
  const [loadingCancel, setLoadingCancel] = useState<boolean>(false);
  const [loadingUpdateCoupon, setLoadingUpdateCoupon] = useState<boolean>(false);

  const autoRechargeLoadedRef = useRef(false);

  const { userData, loadUserData } = useAuth();
  const { confirmDialog, startPlan } = useApp();

  const getCurrentPlanData = () => {
    const directPlan = userData?.plan;
    if (directPlan?._id) return directPlan;
    if (directPlan?.plan?._id) return directPlan.plan;
    if (directPlan?.plan?.plan?._id) return directPlan.plan.plan;
    return directPlan || null;
  }

  const openAddCustomersCheckout = () => {
    const additionalCustomers = parseInt(`${addCustomersForm?.additionalCustomers ?? 0}`);
    if (!additionalCustomers || additionalCustomers < 1) {
      showNotification({ message: "Informe pelo menos 1 cliente adicional", color: "yellow" });
      return;
    }

    const currentPlanData = getCurrentPlanData();
    const currentCustomers = parseInt(`${data?.customers ?? 0}`) || 0;

    startPlan(true, {
      planId: currentPlanData?._id,
      planTitle: currentPlanData?.title,
      additionalCustomers,
      targetCustomers: currentCustomers + additionalCustomers,
      openStep: "review",
    });

    setAddCustomersForm(null);
  }

  const loadDetails = () => {
    setLoading(true)
    GET_BILLING_DETAILS()
      .then((dt) => {
        setLoading(false)
        setData(dt);
        setAutoRecharge(dt.autoRecharge);
        autoRechargeLoadedRef.current = true;
      })
      .catch((err) => {
        setLoading(false)
        showNotification({ message: err.message, color: "red" })
      })
  }

  const handleUpdateMethod = (methodId, push) => {
    setLoadingUpdatePlan(true)
    SAVE_COMPANY_PAYMENT_METHOD({ payment: { method: methodId, push } })
      .then(res => {
        loadUserData();
        setLoadingUpdatePlan(false);
      })
      .catch(err => {
        setLoadingUpdatePlan(false)
        showNotification({ message: err.message, color: "red" })
      })
  }

  // const handleUpdateCoupon = () => {
  //   setLoadingUpdateCoupon(true)
  //   APPLY_COUPON(coupon)
  //   .then(res => {
  //     loadUserData();
  //     setLoadingUpdateCoupon(false);
  //     showNotification({ message: "Discount applied", color: "green" })
  //   })
  //   .catch(err => {
  //     setLoadingUpdateCoupon(false)
  //     showNotification({ message: err.message, color: "red" })
  //   })
  // }

  useEffect(() => {
    loadDetails()
  }, [])

  useEffect(() => {
    setPaymentMethod({ method: userData?.activePaymentMethod?._id });
  }, [userData])

  useEffect(() => {
    if (checkout && !userData?.activePaymentMethod) startPlan();
  }, [checkout, userData])

  return <>
    <LoadingOverlay visible={loading} />
    <Grid mb="md">
      {((userData?.coupon?.value ?? 0) < 100) && <Grid.Col md={6}>
        <Paper p="md" shadow="xs" style={{ minHeight: 320, display: 'flex', flexDirection: 'column' }}>
          <Title order={4}>Seu Plano</Title>
          {/* <Title order={5} fw="lighter" mb="md">{str("BILLING.YOUR_PLAN_SUBTITLE")}</Title> */}

          <Paper shadow='xs' p="md" mb="md" mt="xs" style={{ flex: 1, border: '1px solid #DFDFDF', cursor: 'pointer' }} onClick={() => startPlan()}>
            <Title order={4}>{userData?.plan?.title ?? "Nenhum plano ativo"}</Title>
            {userData?.plan && <>
              {/* <Text c="gray" size="sm">{formatMoney(userData?.plan?.price)}</Text> */}
              {/* <Text c="gray" size="xs">{(userData?.recurrence_type ?? "month")}</Text> */}
            </>}
            <Text c="gray" size="sm" mt="md">{(userData?.plan?.description ?? "").split("\n").map((d) => <div style={{ minHeight: 14 }}>{d}</div>)}</Text>
            {
              userData?.activePaymentMethod && <>
                <Text mt="md" size="xs" ta="right">Próxima Fatura: {moment(data?.nextPayment?.date).format("MMM DD, YYYY")}</Text>
                {(data?.nextPayment?.details ?? []).map(dt => (
                  <Text size="xs" ta="right">{dt.title}: {formatMoney(dt.value)}</Text>
                ))}
                <Text size="xs" ta="right" fw="bold">Total: {formatMoney(data?.nextPayment?.value)}</Text>
              </>
            }
          </Paper>
          <Group mt="md">
            <Text>Clientes: {data?.customers ?? 0}</Text>
            <div style={{ flex: 1 }}></div>
            {!!userData?.plan && <Button variant="light" onClick={() => setAddCustomersForm({ additionalCustomers: 1 })}>Adicionar clientes</Button>}
            <Button onClick={() => startPlan()}>Trocar Plano</Button>
          </Group>
        </Paper>
      </Grid.Col>}

      <Grid.Col md={6}>
        <Paper p="md" shadow="xs" style={{ minHeight: 320, display: 'flex', flexDirection: 'column' }}>
          <Title order={4}>Forma de Pagamento</Title>
          {/* <Title order={5} fw="lighter" mb="md"></Title> */}

          <Box style={{ flex: 1 }} mt="xs">
            <PaymentForm
              data={paymentMethod}
              methods={userData?.paymentMethods}
              onChange={(dt) => {
                setPaymentMethod(pm => ({ ...pm, ...dt }));
                if (dt.method) {
                  handleUpdateMethod(dt.method, false);
                }
              }}
              onSave={(methodId, isNew = false) => {
                setPaymentMethod({ method: methodId, push: isNew })
                setTimeout(() => handleUpdateMethod(methodId, isNew), 300);
              }}
            />
          </Box>

          {userData?.activePaymentMethod ? <Button mt="md" color="white" variant="light" onClick={() => {
            setCancelForm({});
          }}>Cancelar Assinatura</Button> :
          userData?.plan && <Text color="red" size="sm">Assinatura Cancelada</Text>}
          {/* <Group position="right">
              <Button loading={loadingUpdatePlan} onClick={handleUpdateMethod}>Atualizar</Button>
            </Group> */}
        </Paper>
      </Grid.Col>

      <Grid.Col md={12}>
        <Paper p="md" shadow="xs">
          <Title order={4} mb="md">Histórico</Title>

          {
            (data?.payments ?? []).filter(p => p.payed_at && !p.refund_at).length === 0
              ? <Text ta="center" mt="md" size="md" c="gray">Nenhum pagamento</Text>
              : <Table
                data={(data?.payments ?? []).filter(p => p.payed_at && !p.refund_at).sort((a, b) => a.payed_at > b.payed_at ? -1 : 1)}
                columns={[
                  {
                    title: "Data",
                    key: "createdAt",
                    render: (item) => item.payed_at ? getExtenseDatetime(item.payed_at) : ""
                  },
                  {
                    title: "Descrição",
                    key: "details",
                    render: (item) => item.details?.text
                  },
                  {
                    title: "Valor",
                    key: "value",
                    render: (item) => `${formatMoney(item.value)}`
                  },
                  userData?.user?.isAdmin && {
                    title: "Ações",
                    key: "actions",
                    render: (item) => <Menu>
                      <Menu.Target>
                        <ActionIcon><FaEllipsisV /></ActionIcon>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Menu.Item
                          onClick={() => {
                            REFUND_PAYMENT(item._id, item.value)
                              .then(() => {
                                loadDetails()
                                showNotification({ message: "Pagamento estornado", color: "green" })
                              })
                              .catch(err => {
                                showNotification({ message: err.message, color: "red" })
                              })
                          }}
                        >Estornar Pagamento</Menu.Item>
                      </Menu.Dropdown>
                    </Menu>
                  },
                ].filter(nn => nn)}
              />
          }

        </Paper>
      </Grid.Col>
    </Grid>


    <Modal
      opened={!!cancelForm}
      onClose={() => setCancelForm(null)}
    >
      <Stack>
        <InputField
          name="reason"
          value={cancelForm?.reason}
          onChange={({ reason }) => setCancelForm(cf => ({ ...cf, reason }))}
          fieldType={InputFieldTypes.SELECT}
          options={[
            { value: "Preço", label: "Preço (muito caro, não compensa, encontrei opção mais barata)", },
            { value: "Funcionalidades", label: "Funcionalidades (não atendeu minhas necessidades, faltam recursos)", },
            { value: "Qualidade/Experiência", label: "Qualidade/Experiência (dificuldade de uso, bugs, desempenho, suporte insatisfatório)", },
            { value: "Baixo uso", label: "Baixo uso (não estou usando, não preciso mais, não tenho tempo)", },
            { value: "Mudança de situação", label: "Mudança de situação (empresa/projeto encerrado, mudança de estratégia, motivos pessoais)", },
            { value: "Concorrência", label: "Concorrência (encontrei uma solução melhor)", },
            { value: "Motivos financeiros", label: "Motivos financeiros (corte de custos, dificuldades orçamentárias)", },
            { value: "Outro", label: "Outro (descreva o motivo)", },
          ]}
        />
        <InputField
          name="reasonText"
          value={cancelForm?.reasonText}
          onChange={({ reasonText }) => setCancelForm(cf => ({ ...cf, reasonText }))}
          fieldType={InputFieldTypes.TEXTAREA}
        />
        <Group style={{ justifyContent: 'flex-end' }}>
          <Button
            color="gray"
            disabled={loadingCancel}
            onClick={() => {
              setCancelForm(null)
            }}
          >FECHAR</Button>
          <Button
            color="red"
            variant="outline"
            loading={loadingCancel}
            disabled={!cancelForm?.reason || (cancelForm?.reason === "Outro" && (cancelForm?.reasonText ?? "").length < 3)}
            onClick={() => {
              setLoadingCancel(true)
              UNSUBSCRIBE_COMPANY(cancelForm)
                .then(() => {
                  showNotification({ message: "Assinatura cancelada", color: "yellow" });
                  setCancelForm(null)
                  loadUserData();
                })
                .catch((err) => {
                  showNotification({ message: err.message, color: "red" })
                })
                .finally(() => {
                  setLoadingCancel(false);
                })
            }}
          >CANCELAR MEU PLANO</Button>
        </Group>
      </Stack>
    </Modal>

    <Modal
      opened={!!addCustomersForm}
      onClose={() => setAddCustomersForm(null)}
      size="sm"
      title="Adicionar clientes"
    >
      <Stack>
        <Text size="sm" c="dimmed">Informe quantos clientes adicionais deseja contratar no plano atual.</Text>
        <InputField
          title="Clientes adicionais"
          name="additionalCustomers"
          fieldType={InputFieldTypes.QUANTITY}
          min={1}
          value={addCustomersForm?.additionalCustomers ?? 1}
          onChange={({ additionalCustomers }) => {
            setAddCustomersForm((form) => ({ ...form, additionalCustomers }))
          }}
        />
        <Group style={{ justifyContent: 'flex-end' }}>
          <Button variant="light" color="gray" onClick={() => setAddCustomersForm(null)}>Cancelar</Button>
          <Button onClick={openAddCustomersCheckout}>Ir para revisão</Button>
        </Group>
      </Stack>
    </Modal>
  </>
};
